export default __webpack_public_path__ + "static/media/icon_checkin_flag.a330586a.svg";